<div class="dialog-wrapper">
  <mat-dialog-content>
    <p>
      By clicking <b>Confirm Reservation</b> you are agreeing to the T&C's
      outlined in the disclaimer on the previous page and are confirming this
      property meets all of your requirements. Your selection will be sent to
      the reservation team who will book the property. You will receive a
      confirmation email once the booking has been made.
    </p>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button
      class="accent-btn"
      mat-raised-button
      color="accent"
      (click)="onNoClick()">
      No Thanks
    </button>
    <button
      mat-raised-button
      color="primary"
      [mat-dialog-close]="confirmedOfferId()"
      cdkFocusInitial>
      Confirm Reservation
    </button>
  </mat-dialog-actions>
</div>
